import { render, staticRenderFns } from "./CarbonHeader.vue?vue&type=template&id=1109ce84&scoped=true"
import script from "./CarbonHeader.vue?vue&type=script&lang=js"
export * from "./CarbonHeader.vue?vue&type=script&lang=js"
import style0 from "./CarbonHeader.vue?vue&type=style&index=0&id=1109ce84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1109ce84",
  null
  
)

export default component.exports